import React from "react";

const InfoCard = ({ title, value, unit, icon, color }) => {
  return (
    <div className="bg-gray-800 dark:bg-gray-800 rounded-xl p-4 flex items-center justify-between shadow-md hover:shadow-lg transition">
      <div>
        <h3 className="text-sm text-gray-400">{title}</h3>
        <h2 className="text-2xl font-bold">{value} {unit}</h2>
      </div>
      <div className={`text-3xl ${color}`}>{icon}</div>
    </div>
  );
};

export default InfoCard;
